export default function Pagination({
  page,
  setPage,
  pageSize,
  totalRecords,
  loading,
}) {
  // Tính tổng số trang dựa trên dữ liệu hiện có ở frontend
  const totalPages = Math.ceil(totalRecords / pageSize) || 1;

  return (
    <div className="flex items-center justify-between px-4 py-3 border-t border-gray-200 text-xs text-gray-700 bg-white rounded-b-2xl">
      <div className="text-gray-700">
        Hiển thị {totalRecords > 0 ? (page - 1) * pageSize + 1 : 0} - {Math.min(page * pageSize, totalRecords)} trong tổng số <span className="font-semibold">{totalRecords}</span> bản ghi
      </div>

      <div className="flex items-center gap-4">
        <div className="text-gray-500">
          Trang <span className="font-semibold text-primary">{page}</span> / {totalPages}
        </div>
        
        <div className="flex items-center gap-2">
          <button
            onClick={() => setPage((p) => Math.max(1, p - 1))}
            disabled={page === 1 || loading}
            className="px-3 py-1 rounded-lg border border-gray-300 disabled:opacity-40"
          >
            Trang trước
          </button>

          <button
            onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
            disabled={page === totalPages || loading || totalRecords === 0}
            className="px-3 py-1 rounded-lg border border-gray-300 disabled:opacity-40"
          >
            Trang sau
          </button>
        </div>
      </div>
    </div>
  );
}